// extracted by mini-css-extract-plugin
export default {"card":"styles_card__TKYos","gridContainer":"styles_gridContainer__e6AYF"};